










































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Order, OrderStatus } from "../../viewmodels/Order";

@Component({})
export default class extends Vue {
  public collection = app.orderCollection;

  public search: string = "";
  public model: Order = new Order({}, this.collection);
  public selectedModel: Order | null = null;

  public dialog = false;

  public headers = [
    { text: "Id", value: "id" },
    { text: "Customer", value: "customer_name" },
    { text: "Table", value: "table_name" },
    { text: "Waiter", value: "waiter_name" },
    { text: "Status", value: "status" },
    { text: "Actions", value: "" }
  ];

  public deliveryHeaders = [
    { text: "Id", value: "id" },
    { text: "Customer", value: "customer_name" },
    { text: "Table", value: "table_name" },
    { text: "Waiter", value: "waiter_name" },
    { text: "Driver", value: "driver_name" },
    { text: "Status", value: "status" },
    { text: "Actions", value: "" }
  ];

  public mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public remove(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public isClass(item: any, className: string) {
    if (item && item.status) {
      switch (item.status) {
        case OrderStatus.Ordered:
          return className === "ordered";
        case OrderStatus.ReadyForDelivery:
          return className === "ready-for-delivery";
        case OrderStatus.Delivered:
          return className === "delivered";
        case OrderStatus.Paid:
          return className === "paid";
        case OrderStatus.Splitted:
          return className === "splitted";
      }
    }
    return false;
  }

  public close() {
    this.dialog = false;
  }

  public view(item: Order) {
    this.model = item;
    this.dialog = true;
  }
}
